import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-dropdown-checkbox',
  templateUrl: './dropdown-checkbox.component.html',
  styleUrls: ['./dropdown-checkbox.component.scss']
})
export class DropdownCheckboxComponent implements OnInit {
  @Input() items: string[] = [];
  @Input() selectedItems: string[] = [];
  @Output() selectionChange = new EventEmitter<string[]>();

  constructor() {}

  toggleItem(item: string) {
    if (this.selectedItems.includes(item)) {
      this.selectedItems = this.selectedItems.filter((i) => i !== item);
    } else {
      this.selectedItems = [...this.selectedItems, item];
    }
    this.selectionChange.emit(this.selectedItems);
  }

  isSelected(item: string) {
    return this.selectedItems.includes(item);
  }

  clearSelection() {
    this.selectedItems = [];
    this.selectionChange.emit(this.selectedItems);
  }

  ngOnInit() {}
}
